<template>
  <v-dialog
    max-width="400"
    v-model="closeSafety">
    <v-card
      v-if="closeSafety"
      class="dialog-card">
      <div class="pa-3">
        <ModalHeader
          icon="mdi-alert"
          modalTitle="Are you sure?"
          @close="closeSafety = false" />
      </div>
      <div
        class="mx-3 pa-3"
        style="background: rgba(0, 0, 0, 0.06); border-radius: 5px">
        <v-card-text>
          Are you sure you want to close the Graphics Engine?
        </v-card-text>
      </div>

      <div class="modal-footer">
        <v-btn
          @click="closeSafety = false"
          variant="flat">
          <v-icon class="mr-2">mdi-arrow-left-circle</v-icon>
          back
        </v-btn>
        <v-spacer />
        <v-btn
          @click="(stop_player(), (closeSafety = false))"
          variant="flat"
          dark
          style="background-color: var(--inner-background)">
          <v-icon style="font-size: 22px">mdi-check-circle</v-icon>
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
  <v-dialog
    max-width="400"
    v-model="restartSafety">
    <v-card
      v-if="restartSafety"
      class="dialog-card">
      <div class="pa-3">
        <ModalHeader
          icon="mdi-alert"
          modalTitle="Are you sure?"
          @close="restartSafety = false" />
      </div>
      <div
        class="mx-3 pa-3"
        style="background: rgba(0, 0, 0, 0.06); border-radius: 5px">
        <v-card-text>
          Are you sure you want to restart the Graphics Engine?
        </v-card-text>
      </div>

      <div class="modal-footer">
        <v-btn
          @click="restartSafety = false"
          variant="flat">
          <v-icon class="mr-2">mdi-arrow-left-circle</v-icon>
          back
        </v-btn>
        <v-spacer />
        <v-btn
          @click="(restart_player(), (restartSafety = false))"
          variant="flat"
          dark
          style="background-color: var(--inner-background)">
          <v-icon style="font-size: 22px">mdi-restart</v-icon>
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
  <div style="display: flex">
    <div style="font-weight: bold; font-size: 20px">
      <v-icon class="mr-3">mdi-monitor-screenshot</v-icon>
      Graphics Engine
    </div>
    <v-spacer />
    <HelpButton mdx-name="VentuzConfig" />
  </div>
  <v-divider class="mt-3" />
  <div class="config-page-body">
    <div style="margin-top: 40px; margin-bottom: 20px">
      <div></div>
      <v-card-subtitle>Controls</v-card-subtitle>
      <v-divider />
    </div>

    <div
      flat
      style="flex-grow: 1">
      <v-btn
        flat
        class="mr-2"
        v-if="'runtime_onair' in deluge"
        :loading="
          deluge.runtime_onair.status === 'starting' ||
          deluge.runtime_onair.status === 'stopping'
        "
        small
        @click="
          deluge.runtime_onair.online ? (closeSafety = true) : start_player()
        ">
        <v-icon class="mr-2">mdi-power</v-icon>
        <div v-if="deluge.runtime_onair.online">Stop</div>
        <div v-else>Start</div>
      </v-btn>
      <v-btn
        :disabled="!deluge.runtime_onair.online"
        class="mr-2"
        prepend-icon="mdi-restart"
        flat
        @click="restartSafety = true"
        :loading="
          deluge.runtime_onair.status === 'starting' ||
          deluge.runtime_onair.status === 'stopping'
        ">
        Restart
      </v-btn>
    </div>

    <div style="margin-top: 40px; margin-bottom: 20px">
      <v-card-subtitle>Eco Options</v-card-subtitle>
      <v-divider />
      <div
        title="CanvasPro branded Splash Screen on each frame at startup, useful for setting up frames.">
        <v-checkbox
          v-model="ecoModeEnabled"
          label="Enable Eco Period" />
        <div
          style="display: flex; gap: 8px; align-items: center"
          v-if="ecoModeEnabled">
          Shutdown Runtime After
          <!-- native time input with seconds -->
          <input
            type="time"
            step="1"
            v-model="ecoPeriodStart"
            title="Start time (HH:MM:SS)" />
          Start Runtime After:
          <input
            type="time"
            step="1"
            v-model="ecoPeriodEnd"
            title="End time (HH:MM:SS)" />
        </div>
      </div>
      <v-card-subtitle class="mt-4">Startup Config</v-card-subtitle>
      <v-divider />
      <div title="Shuts down the graphics engine for a period of time">
        <v-checkbox
          v-model="splashScreenOnStartup"
          label="Enable splash screens on startup" />
      </div>
      <div title="Auto start Ventuz">
        <v-checkbox
          v-model="autoStartVentuz"
          label="Automatically start Runtime" />
      </div>
      <v-card-subtitle class="mt-4">Explorer Control</v-card-subtitle>
      <v-divider />
      <div
        class="explorer-control-section"
        style="padding: 12px 0">
        <div
          class="explorer-status"
          style="display: flex; align-items: center">
          <v-icon
            :color="explorerRunning ? 'success' : 'grey'"
            class="mr-2">
            {{ explorerRunning ? 'mdi-check-circle' : 'mdi-close-circle' }}
          </v-icon>
          <span>
            Explorer.exe is {{ explorerRunning ? 'running' : 'not running' }}
          </span>
        </div>
        <div
          class="explorer-controls"
          style="
            margin-top: 12px;
            display: flex;
            gap: 12px;
            align-items: center;
            flex-wrap: wrap;
          ">
          <v-btn
            flat
            :loading="explorerActionLoading"
            :disabled="autoKillExplorerEnabled"
            @click="toggleExplorer">
            <v-icon class="mr-2">
              {{ explorerRunning ? 'mdi-close' : 'mdi-play' }}
            </v-icon>
            {{ explorerRunning ? 'Kill Explorer' : 'Start Explorer' }}
          </v-btn>
          <v-switch
            v-model="autoKillExplorerEnabled"
            label="Auto-kill Explorer"
            color="primary"
            density="compact"
            hide-details
            @update:modelValue="toggleAutoKillExplorer"
            title="When enabled, explorer.exe will be automatically killed whenever it starts" />
        </div>
        <div
          v-if="autoKillExplorerEnabled"
          class="text-caption text-grey mt-2">
          <v-icon
            size="small"
            class="mr-1">
            mdi-information-outline
          </v-icon>
          Explorer will be killed automatically whenever it starts
        </div>
      </div>
      <v-card-subtitle class="mt-4">Runtime Config</v-card-subtitle>
      <v-divider />
      <div title="Enable or disable scene/transitions in the renderer">
        <v-checkbox
          v-model="transitionsEnabled"
          label="Transitions Enabled" />
      </div>
      <v-divider
        class="mt-3"
        style="margin-bottom: 12px" />
      <div style="display: flex">
        <v-spacer />
        <v-btn
          color="primary"
          variant="flat"
          class=""
          @click="updateGraphicsConfig()">
          Save
        </v-btn>
      </div>
      <div v-if="state.beta">
        <Suspense>
          <DeviceConfig />
          <template #fallback>
            <div class="loading-graphics-config">
              <v-progress-circular indeterminate />
              Loading Graphics Config...
            </div>
          </template>
        </Suspense>
      </div>
    </div>
  </div>
</template>
<script setup>
import { deluge } from '@/stores/deluge.js';
import { $http } from '../../stores/http.js';
import { state } from '../../stores/deluge.js';
import { ref, onMounted, computed } from 'vue';
import HelpButton from '../Help-Hints/HelpButton.vue';
import ModalHeader from '../Shared/Modals/ModalHeader.vue';
import DeviceConfig from '../Configure/VentuzConfig/DeviceConfig.vue';
// using native time inputs instead of @vuepic/vue-datepicker to reduce bundle size

const save_data = ref({
  auto_start: false,
  timeout: 30,
  auto_close: false,
});
const autoStartVentuz = ref(false);
const ecoModeEnabled = ref(false);
// store HH:MM:SS strings for native time inputs
const ecoPeriodStart = ref(''); // time period where graphics engine is shutdown
const ecoPeriodEnd = ref(''); // time period where graphics engine is shutdown

async function updateGraphicsConfig() {
  let ecoPeriod = undefined;
  if (!ecoModeEnabled.value) {
    ecoPeriodStart.value = '';
    ecoPeriodEnd.value = '';
  } else {
    // expect strings "HH:MM:SS"
    ecoPeriod = {
      start: ecoPeriodStart.value,
      end: ecoPeriodEnd.value,
    };
  }
  await $http(
    'PUT',
    `/update_graphics_config`,

    JSON.stringify({
      eco_period: ecoPeriod,
      auto_restart: autoStartVentuz.value,
      splash_screen_enabled: splashScreenOnStartup.value,
      transitions_enabled: transitionsEnabled.value,
    })
  );
}

const restartSafety = ref(false);
const closeSafety = ref(false);
const splashScreenOnStartup = ref(false);
const transitionsEnabled = ref(true);

// Explorer control state
const explorerActionLoading = ref(false);
const autoKillExplorerEnabled = ref(false);

// Computed property to get explorer running status from Deluge
const explorerRunning = computed(() => {
  return deluge.explorer_status?.running ?? true;
});

async function fetchExplorerStatus() {
  try {
    const response = await $http('GET', '/dynamic_engine/get_explorer_status');
    const data = JSON.parse(response);
    autoKillExplorerEnabled.value = data.auto_kill_enabled || false;
  } catch (error) {
    console.log('Failed to fetch explorer status:', error);
  }
}

async function toggleExplorer() {
  explorerActionLoading.value = true;
  try {
    if (explorerRunning.value) {
      await $http('POST', '/dynamic_engine/kill_explorer');
    } else {
      await $http('POST', '/dynamic_engine/start_explorer');
    }
  } catch (error) {
    console.log('Failed to toggle explorer:', error);
  } finally {
    explorerActionLoading.value = false;
  }
}

async function toggleAutoKillExplorer(enabled) {
  try {
    await $http(
      'POST',
      `/dynamic_engine/toggle_auto_kill_explorer?enabled=${enabled}`
    );
  } catch (error) {
    console.log('Failed to toggle auto-kill explorer:', error);
    // Revert the switch on error
    autoKillExplorerEnabled.value = !enabled;
  }
}

async function changeSplash() {
  await $http(
    'PUT',
    `/set_splashscreen?enabled=${splashScreenOnStartup.value}`
  );
}

onMounted(async () => {
  splashScreenOnStartup.value = deluge.config.ventuz_splashscreen_at_startup;
  autoStartVentuz.value = deluge.config?.extra_info?.auto_restart;
  // default to true when undefined
  transitionsEnabled.value =
    deluge.config?.extra_info?.transitions_enabled ?? true;
  ecoModeEnabled.value =
    deluge.config?.extra_info?.eco_period !== undefined &&
    deluge.config?.extra_info?.eco_period !== null;
  if (ecoModeEnabled.value) {
    const ecoPeriod = deluge.config.extra_info.eco_period;
    ecoPeriodStart.value = {
      hours: ecoPeriod.start.split(':')[0],
      minutes: ecoPeriod.start.split(':')[1],
      seconds: ecoPeriod.start.split(':')[2],
    };
    ecoPeriodEnd.value = {
      hours: ecoPeriod.end.split(':')[0],
      minutes: ecoPeriod.end.split(':')[1],
      seconds: ecoPeriod.end.split(':')[2],
    };
  }
  // await load();

  // Fetch initial explorer status
  await fetchExplorerStatus();
});
async function save() {
  await $http(
    'GET',
    '/dynamic_engine/save_graphics_engine_config?data=' +
      JSON.stringify(save_data.value)
  );
}
async function load() {
  const data = await $http('GET', '/dynamic_engine/get_graphics_engine_config');
  save_data.value = JSON.parse(data);
}
async function download(url, file_name) {
  try {
    const data = await $http('GET', url);
    var element = document.createElement('a');
    element.setAttribute(
      'href',
      'data:text/plain;charset=utf-8,' + encodeURIComponent(data)
    );
    element.setAttribute(
      'download',
      file_name + ' ' + new Date().toISOString() + '.txt'
    );
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  } catch (error) {
    console.log(error);
  }
}
async function start_player() {
  try {
    await $http('GET', '/dynamic_engine/start_renderer');
  } catch (error) {
    console.log(error);
  }
}
async function stop_player() {
  try {
    await $http('GET', '/dynamic_engine/stop_renderer');
  } catch (error) {
    console.log(error);
  }
}
async function restart_player() {
  try {
    await $http('GET', '/dynamic_engine/restart_renderer');
  } catch (error) {
    console.log(error);
  }
}
</script>
<style scoped>
@import './config.css';

.loading-graphics-config {
  margin: 2rem;
}
</style>
